export class MemberActivity {
  public ActivityId: number;
  public ProfileId: number;
  public ActivityTypeId: number;
  public ActivityType: string;
  public ActivityDate: Date;
  public Descr: string;
  public DateCreated: Date;
  public DateChanged: Date;
  public ChangedBy: string;
  public EntityId: number;
  public ExternalId: string;
  public PrimaryEntity;
  public Member: boolean;
  public Prospect: boolean;
  public Source: string;
  public Status: string;
  public MemberSince: Date;
  public ActivityStartDate: Date;
  public ActivityEndDate: Date;
  public BillingId: number;
  public Inactive: boolean;
  public DateInactive: Date;
  public ActivityValue: string;
  public MemberShipLevelId: number;

  public constructor() {
    this.ActivityId = 0;
    this.ProfileId = 0;
    this.ActivityTypeId = 0;
    this.ActivityType = '';
    this.ActivityDate = new Date();
    this.Descr = '';
    this.DateCreated = new Date();
    this.DateChanged = new Date();
    this.ChangedBy = '';
    this.EntityId = 0;
    this.ExternalId = '';
    this.PrimaryEntity;
    this.Member = false;
    this.Prospect = false;
    this.Source = '';
    this.Status = '';
    this.MemberSince = new Date();
    this.ActivityStartDate = new Date();
    this.ActivityEndDate = new Date();
    this.BillingId = 0;
    this.Inactive = false;
    this.DateInactive = new Date();
    this.ActivityValue = '';
    this.MemberShipLevelId = 0;
  }
}
